<template>
  <div class="border-gray-400 rounded-md mb-6 mt-2 md:ml-[100px] sm:ml-0" style="border: 1px solid #dcdfe6ba;">
  <div class="sm:overflow-x-auto overflow-x-scroll w-full">
      <table class="w-full table-auto divide-y divide-gray-200 text-xs md:text-sm lg:text-base">
        <thead class="bg-gray-200 sticky top-0 z-20">
          <tr class="text-[10px] md:text-xs lg:text-sm">
            <th class="px-2 py-2 text-left font-bold text-gray-600 uppercase align-middle" rowspan="2">Date</th>
            <th class="px-2 py-2 text-left font-bold text-gray-600 uppercase align-middle" rowspan="2">Subject</th>
            <th class="px-2 py-2 text-left font-bold text-gray-600 uppercase align-middle" rowspan="2">Total Emails</th>
            <th class="px-2 py-2 text-left font-bold text-gray-600 uppercase align-middle" rowspan="2">Inbox</th>
            <th class="px-2 py-2 text-left font-bold text-gray-600 uppercase align-middle" rowspan="2">Spam</th>
            <!-- Gmail Group Header -->
            <th class="px-2 py-2 text-center font-bold text-gray-600 uppercase bg-red-100" colspan="5">
              Gmail
            </th>
          </tr>
          <!-- Sub Header Row (Gmail Columns) -->
          <tr class="text-[8px] md:text-xs lg:text-sm bg-gray-100">
            <th class="px-4 py-2 text-right font-bold text-gray-600 uppercase align-middle">INBOX  &nbsp;%</th>
            <th class="px-4 py-2 text-right font-bold text-gray-600 uppercase align-middle">SPAM  &nbsp;%</th>
            <th class="px-4 py-2 text-right font-bold text-gray-600 uppercase align-middle">PRIMARY</th>
            <th class="px-4 py-2 text-right font-bold text-gray-600 uppercase align-middle">UPDATE</th>
            <th class="px-4 py-2 text-right font-bold text-gray-600 uppercase align-middle">PROMOTION</th>
          </tr>
        </thead>
        <!-- Table Body -->
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-if="loading">
            <td colspan="12" class="text-center py-8">
              <div class="flex justify-center items-center h-20">
                <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-gray-500"></div>
              </div>
            </td>
          </tr>

          <tr v-else-if="paginatedList && paginatedList.length > 0" v-for="(email, index) in paginatedList" :key="index">
            <td class="px-2 py-3 min-w-[120px]">{{ getDisplayTime(email.date_str) }}</td>

            <!-- Subject wrapping with line-clamp or break-word -->
            <td class="px-2 py-3 break-words whitespace-normal max-w-[250px] min-w-[180px]">
              {{ email.subject || "N/A" }}
            </td>

            <td class="px-2 py-3 min-w-[100px]">{{ email.total_emails || 0 }}</td>
            <td class="px-2 py-3 min-w-[100px]">{{ email.total_inbox || 0 }}</td>
            <td class="px-2 py-3 min-w-[100px]">{{ email.total_spam || 0 }}</td>

            <td class="px-2 min-w-[100px] text-center">
              &nbsp; &nbsp; &nbsp; &nbsp;{{ calculatePercentage(email.gmail_inbox, email.total_emails) || "0%" }}
            </td>
            <td class="px-2 min-w-[100px] text-center">
              &nbsp; &nbsp; &nbsp; &nbsp;{{ calculatePercentage(email.gmail_spam, email.total_emails) || "0%" }}
            </td>
            <td class="px-2 py-3 min-w-[100px] text-center">{{ email.gmail_primary || 0 }}</td>
            <td class="px-2 py-3 min-w-[100px] text-center">{{ email.gmail_update || 0 }}</td>
            <td class="px-2 py-3 min-w-[100px] text-center">{{ email.gmail_promotions || 0 }}</td>
          </tr>

          <tr v-else>
            <td colspan="12" class="text-center py-6 text-gray-500">No data available</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="border-t flex flex-col sm:flex-row justify-center items-center mt-4 px-2 w-full">
      <div class="text-sm text-gray-600 mb-2 sm:mb-0">
        Total <span class="font-medium">{{ pageOptions.total || 0 }}</span> Emails
      </div>
      <div class="pagination pagination-no-borders" v-if="!loading">
        <el-pagination
          @current-change="handlePageChange"
          :current-page="pageOptions.pageNumber"
          :page-size="pageOptions.pageSize"
          layout="prev, pager, next"
          :total="pageOptions.total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>



<script>
import inboxTable from './inboxTable.js';
export default inboxTable;
</script>

<style lang="scss" src="./inboxTable.scss"></style>